import { Button, Modal, Spin } from 'antd';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import { M, G } from '../shared/constants';
import { useReceiptBlob } from '../shared/hooks';

export function ReceiptModal({ payment, open, onClose }) {
  const { blobUrl, loading, error } = useReceiptBlob(payment, open);

  const download = () => {
    if (!blobUrl) return;
    const a    = document.createElement('a');
    a.href     = blobUrl;
    a.download = `receipt_${payment.receipt_no || payment.id}.jpg`;
    a.click();
  };

  const print = () => {
    if (!blobUrl) return;
    const w = window.open(blobUrl, '_blank');
    setTimeout(() => w?.print(), 600);
  };

  if (!payment) return null;
  return (
    <Modal open={open} onCancel={onClose} footer={null} centered width={460}
      title={<span style={{ color: M, fontWeight: 700 }}><PrinterOutlined style={{ marginRight: 8 }} />Receipt{payment.receipt_no ? ` #${payment.receipt_no}` : ''}</span>}>
      <div>
        <div style={{ background: '#f3f4f6', borderRadius: 10, overflow: 'hidden',
          marginBottom: 14, minHeight: 220,
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {loading && <Spin tip="Loading receipt..." />}
          {error && !loading && (
            <div style={{ textAlign: 'center', padding: 24, color: '#6b7280', fontSize: 13 }}>
              <div style={{ fontSize: 36, marginBottom: 8 }}>🧾</div>
              Receipt image not configured yet.<br />
              <span style={{ fontSize: 11 }}>Admin needs to set up the receipt template.</span>
            </div>
          )}
          {blobUrl && !loading && (
            <img src={blobUrl} alt="Receipt"
              style={{ width: '100%', display: 'block', borderRadius: 10 }} />
          )}
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <Button block icon={<DownloadOutlined />} onClick={download} disabled={!blobUrl}
            style={{ borderRadius: 8, background: M, borderColor: M, color: G, fontWeight: 700, height: 42 }}>
            Download
          </Button>
          <Button block icon={<PrinterOutlined />} onClick={print} disabled={!blobUrl}
            style={{ borderRadius: 8, borderColor: '#6b7280', color: '#374151', fontWeight: 600, height: 42 }}>
            Print
          </Button>
        </div>
      </div>
    </Modal>
  );
}
